import { JUST_PUBLISHED_SESSION_KEY } from "../config/constants";

export const getJustPublishedId = (): string | null => {
  try {
    return window.sessionStorage.getItem(JUST_PUBLISHED_SESSION_KEY);
  } catch {
    return null;
  }
};

export const setJustPublishedId = (id: string) => {
  try {
    window.sessionStorage.setItem(JUST_PUBLISHED_SESSION_KEY, id);
  } catch {
    /* no-op */
  }
};

export const clearJustPublishedId = () => {
  try {
    window.sessionStorage.removeItem(JUST_PUBLISHED_SESSION_KEY);
  } catch {
    /* no-op */
  }
};
